export default __webpack_public_path__ + "static/pragicts-secops-services-vapt-2f5638d0d0c1635dbbb53c39ce990fd2.jpg";